import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { SetupService } from 'app/modules/gen/setup/setup.service';
import {FooterService} from './footer.service'
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  currentYear = (new Date()).getFullYear();
  rvw_vle;fcltyLst;
  pgeRvwData;
  constructor(public _footerService:FooterService,public setupService: SetupService,private _changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    console.log(this.pgeRvwData);
    this.getFacilities();
  }
  getFacilities() {
    this.setupService.getFacilityMater().subscribe((res) => {
      if (res['status'] == 200) {
        this.fcltyLst = res['data'];
        // console.log(this.fcltyLst);
        // ChangeDetectorRef since file is loading outside the zone
        this._changeDetectorRef.markForCheck();
        this.pgeRvwData = {
          enty_ky: this.fcltyLst[0].fclty_id,
          hndlr_nm: 'facility',
          rvw_qtn: 'Was this facility page helpful?'
        }
        console.log(this.pgeRvwData);
      }
    })
  }
  shwReview()
  {
    this._footerService.setReviewCtrl(!this._footerService.rvwInput);
  }
}